import React from "react";
import AuthContext from '../store/AuthContext';
import Signup from "../components/account/Signup"
import {Login} from "../components/account/Login"
import {Profile} from "../components/account/Profile"
import {ResetPassword} from "../components/account/ResetPassword"
import NativeInterface from "services/NativeInterface";

enum Mode { Profile, Register, Login, ResetPassword }

const AccountPage = () => {
    const authCtx = React.useContext(AuthContext)
    const [mode, setMode] = React.useState<Mode>(authCtx.account.valid() ? Mode.Profile : Mode.Login)

    React.useEffect(() => {
        if (authCtx.account.valid()) {
            setMode(Mode.Profile)
        } else {
            if (mode == Mode.Profile) {
                setMode(Mode.Login)
            }
        }

        if (NativeInterface.isPWA()) {
            if (/*props.dimension.id == '3382710084' && */!authCtx.account.developer) {
                window.history.pushState(null, '', window.location.href);
                window.history.replaceState(null, '', window.location.href);
            }
        }

    }, [authCtx]);

    return (
        <section className={`section-dimensions-location`}>
            {mode == Mode.Profile && (
                <Profile/>
            )}
            {mode == Mode.Register && (
                <Signup cancelCallback={() => setMode(Mode.Login)}/>
            )}
            {mode == Mode.Login && (
                <Login resetPasswordCallback={() => setMode(Mode.ResetPassword)} registerCallback={() => setMode(Mode.Register)}/>
            )}
            {mode == Mode.ResetPassword && (
                <ResetPassword cancelCallback={() => setMode(Mode.Login)}/>
            )}
        </section>
    );
};

export default AccountPage;
